export default __webpack_public_path__ + "static/media/(11).4daec96a.jpeg";